import { object, string } from "yup";

import Intro from "./steps/Intro";
import ValueCare from "./steps/ValueCare";
import Age from "./steps/Age";
import Property from "./steps/Property";
import Pension from "./steps/Pension";
import Benefits from "./steps/Benefits";
import AccountAssets from "./steps/AccountAssets";
import Expenses from "./steps/Expenses";

export default [

  //screen1
  {
    id: "intro",
    component: Intro,
  },
  //screen 2
  {
    id: "valuecare",
    component: ValueCare,
    initialValues:{
      valueover: "",
      ownproperty: "",
      ownpropertyoutsideuk: "",
      typeofcare: "",
    },
    validationSchema: object().shape({
      valueover: string().required('"Is the total value of your savings over £23,250" is required'),
      typeofcare: string().required('"What type of care do you need?" is required'),
    })
  },
  //screen 3
  {
    id: "age",
    component: Age,
    initialValues:{
      age: "",
      carer: "",
      loneparent: "",
      childrenunder18:""
    },
    validationSchema: object().shape({
      age: string().required('"How old are you?" is required'),
      carer: string().required('"Do you receive or have an entitlement to Carers Allowance?" is required'),
      loneparent: string().required('"Are you a lone parent?" is required'),
    })
  },
   //screen 4
   {
    id: "property",
    component: Property,
    initialValues:{
      propertyvalue: 0.00,
      mortgageloan: 0.00,
      mortgageloanamountvalue: 0.00,
      totalinhome: 0,
      followingapply: ""
    }
  },

  //screen 5
  {
    id: "pension",
    component: Pension,
    initialValues:{
      statepension_name: 0.00,
      "statepension_per": "",
      statepension: 0.00,
      privatepensions_name: 0.00,
      "privatepension_per": "",
      privatepensions:0.00,
      passpensionon:"",
      pensioncredit_name:0.00,  
      "pensioncredit_per":"",
      pensioncredit:0.00,
      pensionsavingscredit: 0.00,
      pensionsavingscredit_name:0.00,
      "pensionsavingscredit_per":""
   }
  },

     // screen 6
     {
      id: "benefits",
      component: Benefits,
      initialValues:{
        attendanceallowance: "",
        disabilityallowance: "",
        disabilitymobility: "",
        personalindepenence: "",
        personalindepenence_mobility: "",
        armedforces: "",
        employmentsupport: 0.00,
        "employmentsuppport_per": "",
        incomesupport_name: 0.00,
        "incomesupport_per": "",
        incomesupport: 0.00,
        universalcredit_name: 0.00,
        "universalcredit_per": "",
        universalcredit: 0.00,
        carersallowance_name: 0.00,
        "carersallowance_per": "", 
        carersallowance: 0.00,
        otherbenefits_name: 0.00,
        "otherbenefits_per": "",
        otherbenefits: 0.00
      },
      validationSchema: object().shape({
        attendanceallowance: string().required('"Attendance Allowance (weekly)" is required'),
        disabilityallowance: string().required('"Disability Living Allowance - care component (weekly)" is required'),
        disabilitymobility: string().required('"Disability Living Allowance - mobility component (weekly)" is required'),
        personalindepenence: string().required('"Personal Independence Payment (PIP) - care component (weekly)" is required'),
        personalindepenence_mobility: string().required('"Personal Independence Payment (PIP) - mobility component (weekly)" is required'),
        armedforces:string().required('"Do you receive Armed Forces Independence Payment (weekly)" is required'),
      })
    },
  

   // screen 6
   {
    id: "accounts",
    component: AccountAssets,
    initialValues:{
      bankaccounts:0.00,
      postoffice:0.00,
      isa:0.00,
      shares:0.00,
      incomebond:0.00,
      premiumbonds:0.00,
      nationalsavingscerts:0.00,
      buildingsociety:0.00,
      otheraccountsassets:0.00,
    }
  },


   // screen 8
   {
    id: "expenses",
    component: Expenses,
    initialValues:{
      mortgage_name:0.00,
      "mortgage_per":"",
      mortgage:0.00,
      rent_name:"",
      "rent_per":"",
      rent:0.00,
      counciltax_name:"",
      "counciltax_per":"",
      counciltax:0.00,
      servicecharge_name:"",
      "servicecharge_per":"",
      servicecharge:0.00,
      watercharge_name:"",
      "watercharge_per":"",
      watercharge:0.00,
      groundrent_name:0.00,
      "groundrent_per":"",
      groundrent:0.00,
      buildinginsurance_name:0.00,
      "buildinginsurance_per":"",
      buildinginsurance:0.00,
      contentsinsurance_name:0.00,
      "contentsinsurance_per":"",
      contentsinsurance:0.00,
    }
  },
  
];